// const HOST = "http://192.168.100.157:3000/api/v2"
const HOST = 'https://gateway.s5.ottomatically.com/api/v2'; // for encryted data
// const HOST = 'http://10.10.130.205:3000/api/v2'; // for encryted data
// const HOST = 'https://api.ottomatically.com/api/v2/'
// 
export default {
    HOST
}
